<div [formGroup]="form">

    <app-simple-file-upload [extensions]="allowedExtensions"
                            formControlName="Fichier">

        <app-shared-icon-button *ngIf="!fileName else changeFileTemplate">
            Ajouter un document <span class="gup-U-color--orange">*</span>
        </app-shared-icon-button>

        <ng-template #changeFileTemplate>

            <div class="flexLine gup-U-margin-bottom--mini">
                <a class="flexLine">
                    <kal-icon>attach_file</kal-icon>
                    <span>{{ fileName }}</span>
                </a>
                <a class="gup-U-margin-left--normal gup-O-link -secondary">Changer de document</a>
            </div>

        </ng-template>

    </app-simple-file-upload>

    <kal-form-field>

        <kal-input formControlName="LibelleLien"
                   label="Libellé du document">
        </kal-input>

    </kal-form-field>

    <kal-form-field>

        <kal-select formControlName="IdStatut"
                    label="Statut"
                    placeholder="Sélectionner un statut">

            <kal-option *ngFor="let status of statusList"
                        [value]="status.Id">
                {{ status.Libelle }}
            </kal-option>

        </kal-select>

    </kal-form-field>

    <kal-form-field>

        <kal-select formControlName="IdCategorie"
                    label="Catégorie"
                    placeholder="Sélectionner une catégorie">

            <kal-option *ngFor="let category of categoryList"
                        [value]="category.Id">
                {{ category.Libelle }}
            </kal-option>

        </kal-select>

        <p>
            <a class="gup-O-link -secondary" (click)="openCategoryEditDialog()">Accéder au paramétrage des
                catégories</a>
        </p>
    </kal-form-field>

    <app-shared-icon-button *ngIf="!shouldDisplayDescription else descriptionInputTemplate"
                            (click)="toggleDescription()">
        Ajouter une description
    </app-shared-icon-button>

    <ng-container *ngIf="!shouldDisplayPostDateRange else dateRangeInputTemplate">
        <div>
            <app-shared-icon-button (click)="togglePostDateRange()">
                Ajouter une période de publication
            </app-shared-icon-button>

            <p class="gup-U-color--400 small gup-U-margin-bottom--normal">
                Le document sera publié sur la période saisie à condition qu'il soit au statut validé.
            </p>
        </div>

    </ng-container>

    <ng-template #descriptionInputTemplate>

        <kal-form-field>

            <kal-textarea label="Description"
                          formControlName="RemarqueLien">
            </kal-textarea>

        </kal-form-field>

    </ng-template>

    <ng-template #dateRangeInputTemplate>

        <app-date-range controlLabel="Période de publication"
                        displayDateEnd
                        formControlName="DatePublicationDocument">
        </app-date-range>

    </ng-template>

    <kal-checkbox formControlName="IsCommentable"
                  kalTheme="switch"
                  label="Autoriser les commentaires"
                  class="gup-U-margin-bottom--small">
    </kal-checkbox>

    <kal-checkbox formControlName="IsLikeable"
                  kalTheme="switch"
                  label="Autoriser les likes">
    </kal-checkbox>

</div>
